import { postNamedQuery } from '../../../../../service'

let idCounter = 0
const nextId = () => `lifeMap_${Date.now()}_${idCounter++}`

export function createInitialLifeMap (config, clientId) {
  const centerId = nextId()
  const nodes = []
  const edges = []

  const lifeMapConfig = config?.lifeMap || config || {}

  nodes.push({
    id: centerId,
    type: 'hexagon',
    position: { x: 0, y: 0 },
    data: {
      nodeProps: {
        size: 'lg',
        handles: [],
        targets: [],
        orientation: lifeMapConfig.hexagonOrientation || 'pointy'
      },
      entityProps: {
        type: 'client',
        levelId: clientId,
        levelTypeId: 201
      },
      displayOptions: {
        image: 'entityProps.avatarUrl',
        header: '',
        description: ''
      }
    }
  })
  const {
    slotCount = 12,
    defaultRingBlock = 'hexagon',
    defaultRingProps = {},
    autoConnectSlots = false
  } = lifeMapConfig

  for (let i = 0; i < slotCount; i++) {
    const slotId = nextId()
    nodes.push({
      id: slotId,
      type: defaultRingBlock,
      position: { x: 0, y: 0 },
      data: {
        slotIndex: i,
        isSlot: true,
        nodeProps: {
          size: 'lg',
          handles: [],
          targets: [],
          orientation: lifeMapConfig.hexagonOrientation || 'pointy'
        }
      },
      displayOptions: {
        header: 'entityProps.description',
        description: 'entityProps.description',
        ...defaultRingProps
      }
    })

    if (autoConnectSlots) {
      edges.push({
        id: `${centerId}->${slotId}`,
        source: centerId,
        target: slotId,
        type: 'lifeMapEdge',
        data: {
          style: lifeMapConfig?.edgeStyle || {}
        }
      })
    }
  }

  return { nodes, edges, centerId }
}

export async function getInitialLinkedEntityData (clientId) {
  const clientData = await postNamedQuery('levels', 'get-client-by-id', { id: clientId })

  return clientData?.data ?? null
}
